import _extends from '@babel/runtime/helpers/esm/extends';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { useTheme } from '@paypalcorp/pp-react-theme';
import { Shimmer } from '@paypalcorp/pp-react-utils';
import '../__generated__/styles/links.css';

var styles = {"ppvx_link":"ppvx_link___3-10-9","ppvx_link--caption":"ppvx_link--caption___3-10-9","ppvx_icon":"ppvx_icon___3-10-9","ppvx_link__left-icon":"ppvx_link__left-icon___3-10-9","ppvx_link--inverse":"ppvx_link--inverse___3-10-9","ppvx_link--secondary":"ppvx_link--secondary___3-10-9","ppvx_link__shimmer":"ppvx_link__shimmer___3-10-9","ppvx--v2":"ppvx--v2___3-10-9","ppvx--v1":"ppvx--v1___3-10-9","ppvx_link--alt":"ppvx_link--alt___3-10-9"};

var _excluded = ["inverse", "secondary", "size", "primaryAlt", "className", "leftIcon", "children", "as", "theme", "isLoading"];
var Link = forwardRef(function (_ref, ref) {
  var _clsx;

  var inverse = _ref.inverse,
      secondary = _ref.secondary,
      size = _ref.size,
      primaryAlt = _ref.primaryAlt,
      className = _ref.className,
      leftIcon = _ref.leftIcon,
      children = _ref.children,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'a' : _ref$as,
      theme = _ref.theme,
      isLoading = _ref.isLoading,
      rest = _objectWithoutProperties(_ref, _excluded);

  // If theme is not directly provided, get from themeContext
  var _theme = useTheme('Link', theme);

  var isV2 = _theme && _theme === 'v2';

  if (_theme !== 'v2') {
    console.warn('Links 1.0 styles are deprecated. Use Links 2.0 styles and refer to our Migration Guide on how to use 2.0 styles/components.');
  }

  if (isV2 && isLoading) {
    return /*#__PURE__*/React.createElement(Shimmer, {
      className: clsx(styles.ppvx_link__shimmer, className),
      hasStyleDefaults: false,
      isInverse: inverse
    }, children);
  }

  if (as === 'a' && rest.target === '_blank') {
    if (!rest.rel) {
      rest.rel = 'noreferrer noopener';
    } else {
      if (!/noreferrer/i.test(rest.rel)) {
        rest.rel = "".concat(rest.rel, " noreferrer");
      }

      if (!/noopener/i.test(rest.rel)) {
        rest.rel = "".concat(rest.rel, " noopener");
      }
    }
  }

  var leftIconElm = leftIcon && /*#__PURE__*/React.createElement("span", {
    className: styles['ppvx_link__left-icon']
  }, leftIcon);
  var cls = clsx(styles.ppvx_link, (_clsx = {}, _defineProperty(_clsx, styles['ppvx_link--inverse'], inverse), _defineProperty(_clsx, styles['ppvx_link--secondary'], secondary), _defineProperty(_clsx, styles['ppvx_link--caption'], size === 'sm'), _defineProperty(_clsx, styles['ppvx_link--alt'], primaryAlt), _clsx), isV2 && styles['ppvx--v2'], className);
  return /*#__PURE__*/React.createElement(as, _extends({
    className: cls,
    ref: ref
  }, rest), leftIconElm, children);
});

export { Link };
